/* The save chain shared by the sections that write to the company record. */
export const savePath = ({ draft, verificationStatus }) => {
  if (draft == null && (verificationStatus === "Completed" || verificationStatus === "Modified")) {
    return "draft";
  }
  if (verificationStatus === "Modified") return "draftEdit";
  return "company";
};

/* Transcribed: a direct write preserves "Requested" and otherwise marks the field Modified. */
export const nextStatus = (current) =>
  current === "Requested" ? "Requested" : "Modified";
